import React from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {BOOLEAN_OPTIONS} from "../../../constants";

const Details = (props) => {
    const {
        data = {
            'all_individuals_are_uk_resident':      '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <FormInput
                required={true}
                name={'all_individuals_are_uk_resident'}
                detailedLabel={'Are all the individuals on this application resident only in the UK for tax purposes?'}
                value={data.all_individuals_are_uk_resident}
                type={'select'}
                options={BOOLEAN_OPTIONS}
                onChange={(value) => onChange('all_individuals_are_uk_resident', value)}
                disabled={disabled}
                error={errors}
            />
        </React.Fragment>
    );
}

export default Details;
